import { create } from "zustand";

// Create a store using the `create` function
const jobDataStore = create((set) => ({
  // Define the state with jobListingData as an object where the key is `page_no` and value is a list of JSON data
  jobListingData: {},
  count: 0,

  // Define actions to modify the state

  // Action to add or update job listings for a specific page number
  setJobListings: (page_no, data) =>
    set((state) => ({
      jobListingData: {
        ...state.jobListingData,
        [page_no]: data, // Add or update job listings for the specific page number
      },
    })),

  // Action to increment page number (for pagination, for example)
  setPageCount: (total_page) =>
    set((state) => ({
      count: total_page,
    })),

  // Reset action (you may want to reset the jobListingData if needed)
  reset: () => set({ count: 0, jobListingData: {} }), // Reset both count and jobListingData
}));

export { jobDataStore };
